const translations = {
  days: {
    en: "DAYS",
    es: "DÍAS",
    fr: "JOURS",
    it: "GIORNI",
    de: "TAGE",
    pl: "DNI",
    pt: "DIAS",
    ch: "天",
    ru: "ДНИ",
    my: "HARI",
    hi: "दिन",
    tr: "GÜN",
  },
  hours: {
    en: "HOURS",
    es: "HORAS",
    fr: "HEURES",
    it: "ORE",
    de: "STUNDEN",
    pl: "GODZINY",
    pt: "HORAS",
    ch: "小时",
    ru: "ЧАСЫ",
    my: "JAM",
    hi: "घंटे",
    tr: "SAAT",
  },
  minutes: {
    en: "MINUTES",
    es: "MINUTOS",
    fr: "MINUTES",
    it: "MINUTI",
    de: "MINUTEN",
    pl: "MINUTY",
    pt: "MINUTOS",
    ch: "分钟",
    ru: "МИНУТЫ",
    my: "MINIT",
    hi: "मिनट",
    tr: "DAKİKA",
  },
  seconds: {
    en: "SECONDS",
    es: "SEGUNDOS",
    fr: "SECONDES",
    it: "SECONDI",
    de: "SEKUNDEN",
    pl: "SEKUNDY",
    pt: "SEGUNDOS",
    ch: "秒",
    ru: "СЕКУНДЫ",
    my: "SAAT",
    hi: "सेकंड",
    tr: "SANİYE",
  },
  last_places_available: {
    en: "Last places available",
    es: "Últimas plazas disponibles",
    fr: "Dernières places disponibles",
    it: "Ultimi posti disponibili",
    de: "Letzte verfügbare Plätze",
    pl: "Ostatnie dostępne miejsca",
    pt: "Últimos lugares disponíveis",
    ch: "最后剩余的位置",
    ru: "Последние доступные места",
    my: "Tempat terakhir yang tersedia",
    hi: "अंतिम उपलब्ध स्थान",
    tr: "Son kalan yerler",
  },
  male: {
    en: "Male",
    es: "Masculino",
    fr: "Mâle",
    it: "Maschio",
    de: "Männlich",
    pt: "Macho",
    ch: "男性",
    ru: "мужской",
    my: "lelaki",
    hi: "पुरुष",
    tr: "Erkek",
  },
  female: {
    en: "Female",
    es: "Femenino",
    fr: "Femelle",
    it: "Femmina",
    de: "Weiblich",
    pt: "Fêmea",
    ch: "女性",
    ru: "женский",
    my: "perempuan",
    hi: "महिला",
    tr: "Kadın",
  },
  other_gender: {
    en: "Other",
    es: "Otro",
    fr: "Autre",
    it: "Altro",
    de: "Andere",
    pt: "Outro",
    ch: "其他",
    ru: "другой",
    my: "lain",
    hi: "अन्य",
    tr: "Diğer",
  },
  noAvailabilityToday: {
    en: "No available today",
    es: "No disponible hoy",
    fr: "Pas disponible aujourd",
    it: "Non disponibile oggi",
    de: "Heute nicht verfügbar",
    pl: "Dzisiaj niedostępny",
    pt: "Não disponível hoje",
    ch: "今天没有空位",
    ru: "Сегодня нет доступных мест",
    my: "Tidak ada ketersediaan hari ini",
    hi: "आज उपलब्ध नहीं है",
    tr: "Bugün uygun değil",
  },
  availableAt: {
    en: "Available in",
    es: "Disponible en",
    fr: "Disponible en",
    it: "Disponibile in",
    de: "Verfügbar in",
    pl: "Dostępny w",
    pt: "Disponível em",
    ch: "在",
    ru: "Доступно в",
    my: "Tersedia di",
    hi: "में उपलब्ध",
    tr: "Mevcut",
  },
  sentMessage: {
    en: "Your message has been sent",
    es: "Tu mensaje ha sido enviado",
    fr: "Votre message a été envoyé",
    it: "Il tuo messaggio è stato inviato",
    de: "Ihre Nachricht wurde gesendet",
    pl: "Twoja wiadomość została wysłana",
    pt: "Sua mensagem foi enviada",
    ch: "您的消息已发送",
    ru: "Ваше сообщение было отправлено",
    my: "Mesej anda telah dihantar",
    hi: "आपका संदेश भेज दिया गया है",
    tr: "Mesajınız gönderildi",
  },
  startDate: {
    en: "Start date",
    es: "Fecha de inicio",
    fr: "Date de début",
    it: "Data di inizio",
    de: "Startdatum",
    pl: "Data rozpoczęcia",
    pt: "Data de início",
    ch: "开始日期",
    ru: "Дата начала",
    my: "Tarikh mula",
    hi: "प्रारंभ तिथि",
    tr: "Başlangıç tarihi",
  },
  endDate: {
    en: "End date",
    es: "Fecha de fin",
    fr: "Date de fin",
    it: "Data di fine",
    de: "Enddatum",
    pl: "Data zakończenia",
    pt: "Data final",
    ch: "结束日期",
    ru: "Дата окончания",
    my: "Tarikh tamat",
    hi: "अंतिम तिथि",
    tr: "Bitiş tarihi",
  },
  dateRange: {
    en: "Date range",
    es: "Rango de fechas",
    fr: "Plage de dates",
    it: "Intervallo di date",
    de: "Datumsbereich",
    pl: "Zakres dat",
    hi: "तिथि सीमा",
    ms: "Julat tarikh",
    tr: "Tarih aralığı",
  },
  confirm: {
    en: "Confirm",
    es: "Confirmar",
    fr: "Confirmer",
    it: "Confermare",
    de: "Bestätigen",
    pl: "Potwierdzać",
    hi: "पुष्टि करें",
    ms: "Mengesahkan",
    tr: "Onaylamak",
  },
  amount: {
    en: "Amount",
    es: "Cantidad",
    fr: "Montant",
    it: "Quantità",
    de: "Menge",
    pl: "Ilość",
    hi: "मात्रा",
    ms: "Jumlah",
    tr: "Miktar",
  },
  enterAmount: {
    en: "Enter amount",
    es: "Introduce cantidad",
    fr: "Entrez le montant",
    it: "Inserisci importo",
    de: "Menge eingeben",
    pl: "Wprowadź ilość",
    hi: "राशि दर्ज करें",
    ms: "Masukkan jumlah",
    tr: "Miktar girin",
  },
  selectTimeRequired: {
    en: "Time required",
    es: "Tiempo obligatorio",
    fr: "Temps requis",
    it: "Tempo richiesto",
    de: "Erforderliche Zeit",
    pl: "Wymagany czas",
    hi: "आवश्यक समय",
    ms: "Masa diperlukan",
    tr: "Gerekli zaman",
  },
  totalPrice: {
    en: "Total",
    es: "Total",
    fr: "Total",
    it: "Totale",
    de: "Gesamt",
    pl: "Całkowity",
    hi: "कुल",
    ms: "Jumlah keseluruhan",
    tr: "Toplam",
  },
  totalDuration: {
    en: "Total duration",
    es: "Duración total",
    fr: "Durée totale",
    it: "Durata totale",
    de: "Gesamtdauer",
    pl: "Całkowity czas trwania",
    hi: "कुल अवधि",
    ms: "Jumlah keseluruhan",
    tr: "Toplam süre",
  },
  confirmedBooking: {
    en: "Confirmed booking",
    es: "Reserva confirmada",
    fr: "Réservation confirmée",
    it: "Prenotazione confermata",
    de: "Bestätigte Buchung",
    pl: "Potwierdzona rezerwacja",
    pt: "Reserva confirmada",
    ch: "已确认预订",
    ru: "Подтвержденное бронирование",
    hi: "पुष्टि की गई बुकिंग",
    ms: "Tempahan disahkan",
    tr: "Onaylanmış rezervasyon",
  },
  pendingBooking: {
    en: "Pending booking",
    es: "Reserva pendiente",
    fr: "Réservation en attente",
    it: "Prenotazione in sospeso",
    de: "Ausstehende Buchung",
    pl: "Oczekująca rezerwacja",
    pt: "Reserva pendente",
    ch: "待定预订",
    ru: "Ожидающее бронирование",
    hi: "बुकिंग पेंडिंग",
    ms: "Tempahan tertunda",
    tr: "Bekleyen rezervasyon",
  },
  failedBooking: {
    en: "Failed booking",
    es: "Reserva fallida",
    fr: "Réservation échouée",
    it: "Prenotazione fallita",
    de: "Fehlgeschlagene Buchung",
    pl: "Nieudana rezerwacja",
    pt: "Reserva falhada",
    ch: "预订失败",
    ru: "Неудачное бронирование",
    hi: "बुकिंग विफल",
    ms: "Tempahan gagal",
    tr: "Başarısız rezervasyon",
  },
  youHaveScheduledAnEventWith: {
    en: "You have scheduled an event with",
    es: "Has programado un evento con",
    fr: "Vous avez programmé un événement avec",
    it: "Hai programmato un evento con",
    de: "Sie haben eine Veranstaltung mit",
    pl: "Zaplanowałeś wydarzenie z",
    pt: "Você agendou um evento com",
    ch: "您已安排了一个活动",
    ru: "Вы запланировали мероприятие с",
    my: "Anda telah menjadualkan acara dengan",
    hi: "आपने के साथ एक घटना की योजना बनाई है",
    tr: "Bir etkinlik planladınız",
  },
  noAvailableTimeSlots: {
    en: "No available time slots for this day",
    es: "No hay franjas horarias disponibles para este día",
    fr: "Aucune plage horaire disponible pour ce jour",
    it: "Nessuna fascia oraria disponibile per questo giorno",
    de: "Keine verfügbaren Zeitfenster für diesen Tag",
    pl: "Brak dostępnych przedziałów czasowych na ten dzień",
    pt: "Não há horários disponíveis para este dia",
    ch: "当天没有可用的时间段",
    ru: "Нет доступных временных слотов на этот день",
    my: "Tiada slot masa yang tersedia untuk hari ini",
    hi: "इस दिन के लिए कोई उपलब्ध समय स्लॉट नहीं है",
    tr: "Bu gün için uygun zaman dilimi yok",
  },
  emailValidationText: {
    en: "Sorry, this email is not valid",
    es: "Lo sentimos, este correo electrónico no es válido",
    fr: "Désolé, cet e-mail n'est pas valide",
    it: "Spiacenti, questa email non è valida",
    de: "Entschuldigung, diese E-Mail ist nicht gültig",
    pl: "Przykro mi, ten e-mail jest nieprawidłowy",
    pt: "Desculpe, este e-mail não é válido",
    ch: "抱歉，此电子邮件无效",
    ru: "Извините, этот адрес электронной почты недействителен",
    my: "Maaf, e-mel ini tidak sah",
    hi: "क्षमा करें, यह ईमेल मान्य नहीं है",
    tr: "Üzgünüm, bu e-posta geçerli değil"
  },
  fileValidationText: {
    en: "Sorry, this file is not valid",
    es: "Lo sentimos, este archivo no es válido",
    fr: "Désolé, ce fichier n'est pas valide",
    it: "Spiacenti, questo file non è valido",
    de: "Entschuldigung, diese Datei ist nicht gültig",
    pl: "Przykro mi, ten plik jest nieprawidłowy",
    pt: "Desculpe, este arquivo não é válido",
    ch: "抱歉，此文件无效",
    ru: "Извините, этот файл недействителен",
    my: "Maaf, fail ini tidak sah",
    hi: "क्षमा करें, यह फ़ाइल मान्य नहीं है",
    tr: "Üzgünüm, bu dosya geçerli değil"
  },
  zipcodeValidationText: {
    en: "Sorry, this zip code is not valid",
    es: "Lo sentimos, este código postal no es válido",
    fr: "Désolé, ce code postal n'est pas valide",
    it: "Spiacenti, questo codice postale non è valido",
    de: "Entschuldigung, diese Postleitzahl ist nicht gültig",
    pl: "Przykro mi, ten kod pocztowy jest nieprawidłowy",
    pt: "Desculpe, este código postal não é válido",
    ch: "抱歉，此邮政编码无效",
    ru: "Извините, этот почтовый индекс недействителен",
    my: "Maaf, poskod ini tidak sah",
    hi: "क्षमा करें, यह ज़िप कोड मान्य नहीं है",
    tr: "Üzgünüm, bu posta kodu geçerli değil"
  },
  telValidationText: {
    en: "Sorry, this phone number is not valid",
    es: "Lo sentimos, este número de teléfono no es válido",
    fr: "Désolé, ce numéro de téléphone n'est pas valide",
    it: "Spiacenti, questo numero di telefono non è valido",
    de: "Entschuldigung, diese Telefonnummer ist nicht gültig",
    pl: "Przykro mi, ten numer telefonu jest nieprawidłowy",
    pt: "Desculpe, este número de telefone não é válido",
    ch: "抱歉，此电话号码无效",
    ru: "Извините, этот номер телефона недействителен",
    my: "Maaf, nombor telefon ini tidak sah",
    hi: "क्षमा करें, यह फोन नंबर मान्य नहीं है",
    tr: "Üzgünüm, bu telefon numarası geçerli değil"
  },
  urlValidationText: {
    en: "Please use a https:// or http:// URL.",
    es: "Utiliza una URL de https:// o http://.",
    fr: "Veuillez utiliser une URL https:// ou http://.",
    it: "Utilizza un URL di https:// o http://.",
    de: "Bitte verwenden Sie eine https:// oder http:// URL.",
    pl: "Użyj adresu URL https:// lub http://.",
    pt: "Use uma URL https:// ou http://.",
    ch: "请使用 https:// 或 http:// URL。",
    ru: "Пожалуйста, используйте URL-адрес https:// или http://.",
    my: "Sila gunakan URL https:// atau http://.",
    hi: "कृपया एक https:// या http:// यूआरएल का उपयोग करें।",
    tr: "Lütfen bir https:// veya http:// URL'si kullanın."
  },
  numberValidationText: {
    en: "This is not a number",
    es: "Este no es un número",
    fr: "Ce n'est pas un nombre",
    it: "Questo non è un numero",
    de: "Das ist keine Zahl",
    pl: "To nie jest liczba",
    pt: "Isto não é um número",
    ch: "这不是一个数字",
    ru: "Это не число",
    my: "Ini bukan nombor",
    hi: "यह एक संख्या नहीं है",
    tr: "Bu bir sayı değil"
  },
  requiredValidationText: {
    en: "This field is required",
    es: "Este campo es obligatorio",
    fr: "Ce champ est requis",
    it: "Questo campo è obbligatorio",
    de: "Dieses Feld ist erforderlich",
    pl: "To pole jest wymagane",
    pt: "Este campo é obrigatório",
    ch: "此字段为必填项",
    ru: "Это поле обязательно для заполнения",
    my: "Medan ini diperlukan",
    hi: "यह फ़ील्ड आवश्यक है",
    tr: "Bu alan gereklidir"
  },
  maxNumberValidationText: {
    en: "The max value is {max}",
    es: "El valor máximo es {max}",
    fr: "La valeur maximale est {max}",
    it: "Il valore massimo è {max}",
    de: "Der Maximalwert ist {max}",
    pl: "Maksymalna wartość to {max}",
    pt: "O valor máximo é {max}",
    ch: "最大值为 {max}",
    ru: "Максимальное значение {max}",
    my: "Nilai maksimum ialah {max}",
    hi: "अधिकतम मान {max} है",
    tr: "Maks değer {max}"
  },
  minNumberValidationText: {
    en: "The min value is {min}",
    es: "El valor mínimo es {min}",
    fr: "La valeur minimale est {min}",
    it: "Il valore minimo è {min}",
    de: "Der Minimalwert ist {min}",
    pl: "Minimalna wartość to {min}",
    pt: "O valor mínimo é {min}",
    ch: "最小值为 {min}",
    ru: "Минимальное значение {min}",
    my: "Nilai minimum ialah {min}",
    hi: "न्यूनतम मान {min} है",
    tr: "Minimum değer {min}"
  },
  maxAmountValidationText: {
    en: "The max amount is {max}",
    es: "La cantidad máxima es {max}",
    fr: "Le montant maximum est {max}",
    it: "L'importo massimo è {max}",
    de: "Der Maximalbetrag beträgt {max}",
    pl: "Maksymalna kwota to {max}",
    pt: "O valor máximo é {max}",
    ch: "最大金额为 {max}",
    ru: "Максимальная сумма {max}",
    my: "Jumlah maksimum ialah {max}",
    hi: "अधिकतम राशि {max} है",
    tr: "Maksimum miktar {max}"
  },
  minAmountValidationText: {
    en: "The min amount is {min}",
    es: "La cantidad mínima es {min}",
    fr: "Le montant minimum est {min}",
    it: "L'importo minimo è {min}",
    de: "Der Mindestbetrag beträgt {min}",
    pl: "Minimalna kwota to {min}",
    pt: "O valor mínimo é {min}",
    ch: "最小金额为 {min}",
    ru: "Минимальная сумма {min}",
    my: "Jumlah minimum ialah {min}",
    hi: "न्यूनतम राशि {min} है",
    tr: "Minimum miktar {min}"
  },
  bookingCategoryRequiredValidationText: {
    en: "Booking category is required",
    es: "Se requiere categoría de reserva",
    fr: "La catégorie de réservation est requise",
    it: "La categoria di prenotazione è obbligatoria",
    de: "Buchungskategorie ist erforderlich",
    pl: "Kategoria rezerwacji jest wymagana",
    pt: "A categoria de reserva é obrigatória",
    ch: "预订类别是必需的",
    ru: "Требуется категория бронирования",
    my: "Kategori tempahan diperlukan",
    hi: "बुकिंग श्रेणी आवश्यक है",
    tr: "Rezervasyon kategorisi gereklidir"
  },
  maxDurationValidationText: {
    en: "The max duration is {max} days",
    es: "La duración máxima es de {max} días",
    fr: "La durée maximale est de {max} jours",
    it: "La durata massima è di {max} giorni",
    de: "Die maximale Dauer beträgt {max} Tage",
    pl: "Maksymalny czas trwania to {max} dni",
    pt: "A duração máxima é de {max} dias",
    ch: "最大持续时间为 {max} 天",
    ru: "Максимальная продолжительность {max} дней",
    my: "Tempoh maksimum ialah {max} hari",
    hi: "अधिकतम अवधि {max} दिन है",
    tr: "Maksimum süre {max} gündür"
  },
  minDurationValidationText: {
    en: "The min duration is {min} days",
    es: "La duración mínima es de {min} días",
    fr: "La durée minimale est de {min} jours",
    it: "La durata minima è di {min} giorni",
    de: "Die Mindestdauer beträgt {min} Tage",
    pl: "Minimalny czas trwania to {min} dni",
    pt: "A duração mínima é de {min} dias",
    ch: "最小持续时间为 {min} 天",
    ru: "Минимальная продолжительность {min} дней",
    my: "Tempoh minimum ialah {min} hari",
    hi: "न्यूनतम अवधि {min} दिन है",
    tr: "Minimum süre {min} gündür"
  },
  bookingDateRangeRequiredValidationText: {
    en: "Booking date range is required",
    es: "El rango de fechas de reserva es obligatorio",
    fr: "La plage de dates de réservation est requise",
    it: "L'intervallo di date di prenotazione è obbligatorio",
    de: "Der Buchungszeitraum ist erforderlich",
    pl: "Zakres dat rezerwacji jest wymagany",
    pt: "O intervalo de datas da reserva é obrigatório",
    ch: "预订日期范围是必需的",
    ru: "Требуется диапазон дат бронирования",
    my: "Julat tarikh tempahan diperlukan",
    hi: "बुकिंग तिथि सीमा आवश्यक है",
    tr: "Rezervasyon tarih aralığı gereklidir"
  },
  bookingDateRequiredValidationText: {
    en: "Booking date is required",
    es: "Se requiere fecha de reserva",
    fr: "La date de réservation est requise",
    it: "La data di prenotazione è obbligatoria",
    de: "Das Buchungsdatum ist erforderlich",
    pl: "Data rezerwacji jest wymagana",
    pt: "A data da reserva é obrigatória",
    ch: "预订日期是必需的",
    ru: "Требуется дата бронирования",
    my: "Tarikh tempahan diperlukan",
    hi: "बुकिंग तिथि आवश्यक है",
    tr: "Rezervasyon tarihi gereklidir"
  },
}

export default translations;
